/* eslint-disable array-callback-return */

const ICON_CLOSE =
  '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="6.36 6.36 14.14 14.14" aria-hidden="true"><rect x="7.07031" y="6.36396" width="19" height="1" transform="rotate(45 7.07031 6.36396)" fill="currentColor"/><rect x="20.5059" y="7.07107" width="19" height="1" transform="rotate(135 20.5059 7.07107)" fill="currentColor"/></svg>'

const ICON_NOTIFY =
  '<svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.64453 0.00195312C9.66494 0.00263306 9.68497 0.00501459 9.70508 0.00878906H9.71289C9.71661 0.00956008 9.71995 0.011822 9.72363 0.0126953C9.73951 0.0164626 9.75512 0.0206511 9.77051 0.0263672C9.77712 0.0288273 9.7836 0.031386 9.79004 0.0341797C9.80431 0.0403599 9.81843 0.0467818 9.83203 0.0546875C9.83697 0.0575564 9.84188 0.060406 9.84668 0.0634766C9.86014 0.0720998 9.8732 0.0814196 9.88574 0.0917969C9.89394 0.0985529 9.90155 0.105906 9.90918 0.113281C9.91477 0.118704 9.92143 0.124073 9.92676 0.129883C9.92895 0.132286 9.93049 0.135253 9.93262 0.137695C9.93966 0.145751 9.94576 0.154481 9.95215 0.163086C9.96019 0.173963 9.96782 0.184849 9.97461 0.196289C9.98066 0.206428 9.98606 0.216846 9.99121 0.227539C9.99481 0.235064 9.99885 0.242315 10.002 0.25C10.0157 0.283756 10.0233 0.319806 10.0273 0.357422C10.0283 0.366896 10.0299 0.376236 10.0303 0.385742C10.0304 0.390456 10.0322 0.395636 10.0322 0.400391V6.25488C10.032 6.45199 9.95287 6.64186 9.81348 6.78125C9.67403 6.9205 9.48418 6.99889 9.28711 6.99902H1.71191C1.5149 6.99902 1.32506 6.92031 1.18555 6.78125C1.04615 6.64186 0.967024 6.45199 0.966797 6.25488V0.378906C0.970802 0.301028 0.999042 0.224823 1.04883 0.15918C1.06893 0.132599 1.0912 0.107733 1.11719 0.0869141C1.12751 0.0786711 1.13849 0.0715346 1.14941 0.0644531C1.1581 0.0587917 1.16664 0.0528373 1.17578 0.0478516C1.18272 0.0440918 1.19016 0.0414088 1.19727 0.0380859C1.21114 0.031554 1.22555 0.0264102 1.24023 0.0214844C1.24769 0.0190002 1.25512 0.0166838 1.2627 0.0146484C1.27645 0.0109281 1.29038 0.00810175 1.30469 0.00585938C1.31669 0.00397895 1.32871 0.00371834 1.34082 0.00292969C1.34943 0.00237454 1.35844 0 1.36719 0H9.63184L9.64453 0.00195312ZM5.76953 4.4834C5.6359 4.6057 5.43935 4.62085 5.29004 4.5293L5.22949 4.4834L1.76758 1.30957V6.19922H9.23145V1.30957L5.76953 4.4834ZM5.49902 3.64551L8.60254 0.800781H2.39648L5.49902 3.64551Z" fill="currentColor"/></svg>'

const OPTION_LABELS = ['Size', 'Fit', 'Cup']

function parseSkuValues (sku) {
  return sku.name.split(' / ').slice(0, OPTION_LABELS.length)
}

function deriveOptionNames (skus, hasCupSize = false) {
  const first = skus[0]
  if (!first) return [OPTION_LABELS[0]]
  const count = parseSkuValues(first).length
  const names = OPTION_LABELS.slice(0, count)
  if (hasCupSize && count >= 2) names[1] = 'Cup Size'
  return names
}

function hasCupSizeOption (customFields = []) {
  const field = customFields.find(f => f.key === 'filters-cup_size')
  if (!field?.value) return false
  try {
    const parsed = JSON.parse(field.value)
    return Array.isArray(parsed) && parsed.length > 0
  } catch {
    return false
  }
}

function getOptionValues (skus, optionIndex) {
  const values = []
  skus.forEach(sku => {
    const value = parseSkuValues(sku)[optionIndex]
    if (value && !values.includes(value)) values.push(value)
  })
  return values
}

function isSkuBuyable (sku, hasPurpleDotPreorder) {
  return (
    sku.inventoryLevel > 0 || (hasPurpleDotPreorder && sku.inventoryLevel < 0)
  )
}

function buildVariantData (skus, hasPurpleDotPreorder) {
  return skus.map(sku => {
    const values = parseSkuValues(sku)
    return {
      id: Number(sku.id),
      available: isSkuBuyable(sku, hasPurpleDotPreorder),
      option1: values[0] || null,
      option2: values[1] || null,
      option3: null,
      options: values,
      title: values.join(' / '),
    }
  })
}

function quickBuyOptionsTemplate (product) {
  const skus = product.variants
  const optionNames = deriveOptionNames(skus, product.hasCupSize)
  const hasPurpleDotPreorder = product.tags.includes(
    'purple-dot-has-variant-on-preorder',
  )
  const variants = buildVariantData(skus, hasPurpleDotPreorder)

  const isDelisted = product.tags.includes('delisted')
  const stockMessage = product.tags.includes('coming_soon_oos')
    ? window.theme.strings.products.back_in_stock.coming_soon
    : window.theme.strings.products.back_in_stock.notify_me

  const defaultSku =
    skus.find(sku => isSkuBuyable(sku, hasPurpleDotPreorder)) || skus[0]
  const defaultValues = parseSkuValues(defaultSku)

  const stepsHtml = optionNames
    .map((optionName, index) => {
      const values = getOptionValues(skus, index)
      const hasSmallValue = values.some(value => value.length < 3)
      const step = index + 1
      const optionIndex = `${product.id}option${step}`
      const selectId = `SingleOptionSelector-${product.id}-${index}`
      const defaultValue = defaultValues[index]
      const isHidden = index > 0

      const buttonsHtml = values
        .map(value => {
          return `
            <button
              type="button"
              class="qb-Options_Button"
              data-value="${value}"
              data-title="${value}"
              data-product-options-el="trigger"
              data-variant-selects-option
              data-index="${optionIndex}"
              ${value === defaultValue ? 'aria-pressed="true"' : ''}
            >
              <span class="qb-Options_Value fz-12_17">
                ${value}
              </span>

              <span class="qb-Options_Background"></span>

              ${
                !isDelisted
                  ? `<span class="qb-Options_Icon">
                  ${ICON_NOTIFY}
                  <span class="util-ScreenReaderOnly">
                    ${stockMessage}
                  </span>
                </span>`
                  : ''
              }
            </button>
          `
        })
        .join('')

      const optionElements = values
        .map(
          value =>
            `<option value="${value}"${
              value === defaultValue ? ' selected="selected"' : ''
            }>${value}</option>`,
        )
        .join('')

      return `
        <div
          class="qb-Options_Option${
            hasSmallValue ? ' qb-Options_Option-small' : ''
          }"
          data-product-options-el="step"
          data-step="${step}"
          ${isHidden ? 'hidden' : ''}
        >
          <label
            class="qb-Options_Label fz-12_20"
            for="${selectId}"
          >
            <span class="qb-Options_LabelText">${optionName}:</span>
          </label>

          <div class="qb-Options_Buttons">
            ${buttonsHtml}
          </div>

          <select
            class="qb-Options_Select util-ScreenReaderOnly"
            id="${selectId}"
            data-index="${optionIndex}"
            name="options[${optionName}]"
            data-product-options-el="select"
            form="product-form-nosto-${product.id}"
            hidden
          >
            ${optionElements}
          </select>
        </div>
      `
    })
    .join('')

  return `
    <product-options
      class="qb-Options"
      data-steps-total="${optionNames.length}"
    >
      <variant-selects data-section="product-quickbuy" data-url="${
        product.url
      }" data-product-id="${product.id}">
        ${stepsHtml}

        <script data-product-options type="application/json">
          ${JSON.stringify(variants)}
        </script>
      </variant-selects>
    </product-options>
  `
}

function quickBuyProductFormTemplate (product) {
  const hasPurpleDotPreorder = product.tags.includes(
    'purple-dot-has-variant-on-preorder',
  )
  const firstAvailable = product.variants.find(sku =>
    isSkuBuyable(sku, hasPurpleDotPreorder),
  )
  const defaultVariant = firstAvailable || product.variants[0]
  const isAvailable = !!firstAvailable
  const isEmbellished =
    product.tags.includes('Embellished') && window.theme.embellishedProductAddon

  const stockMessage = product.tags.includes('coming_soon_oos')
    ? window.theme.strings.products.back_in_stock.coming_soon
    : window.theme.strings.products.back_in_stock.notify_me

  return `
    <product-form>
      <form
        method="post"
        action="/cart/add"
        accept-charset="UTF-8"
        class="prd-QuickBuy_Form gtm-Atc_ProductPage"
        id="product-form-nosto-${product.id}"
        data-push-cart-form
        data-product-form
        data-product-handle="${product.handle}"
        data-product-drawer-external-el="quickbuy-product-form"
        data-gtm-target-context="quickbuy-product-form"
      >
        <input type="hidden" name="form_type" value="product">
        <input type="hidden" name="utf8" value="✓">

        <div class="prd-QuickBuy_Options">
          ${quickBuyOptionsTemplate(product)}

          <input type="hidden" name="id" value="${defaultVariant.id}">
          <input type="hidden" name="quantity" value="1">

          ${
            isEmbellished
              ? '<input type="hidden" name="properties[_embellished_product]" value="true">'
              : ''
          }

          <div
            class="prd-QuickBuy_Buttons"
            data-product-options-external-el="quickbuyButtons"
            hidden
          >
            <button
              class="prd-QuickBuy_Button prd-QuickBuy_Button-addtocart btn-Button btn-Button-tertiary btn-Button-fullWidth btn-Button-square"
              type="submit"
              name="add"
              aria-hidden="${isAvailable ? 'false' : 'true'}"
              data-back-in-stock-enabled="true"
              ${!isAvailable ? 'disabled="disabled"' : ''}
              data-product-quick-buy-add-to-cart
              data-product-add-to-cart
              data-ab-tasty-atc="product_card_atc"
              data-product-card-external-el="submit"
              data-product-quick-buy-mobile-external-el="submit"
            >
              <span class="prd-QuickBuy_ButtonText" data-product-quick-buy-add-to-cart-text>
                ${
                  isAvailable
                    ? window.theme.strings.products.product.add_to_cart
                    : window.theme.strings.products.product.sold_out
                }
              </span>
            </button>

            <button
              class="prd-QuickBuy_Button prd-QuickBuy_Button-backInStock btn-Button btn-Button-primary btn-Button-fullWidth btn-Button-square"
              type="button"
              aria-hidden="${isAvailable ? 'true' : 'false'}"
              data-product-quick-buy-back-in-stock
              data-product-id="${product.id}"
              data-variant-id="${defaultVariant.id}"
              data-product-price="${product.price}"
              data-product-url="${window.location.host}${product.url}"
              data-back-in-stock-external-el="trigger"
              data-drawers-trigger="back-in-stock"
              data-product-back-in-stock
            >
              ${stockMessage}
            </button>
          </div>
        </div>
      </form>
    </product-form>
  `
}

function singleVariantAddToCartTemplate (product) {
  const variant = product.variants[0]

  return `
    <div class="prd-AddToCart">
      <product-form>
        <form
          method="post"
          action="/cart/add"
          accept-charset="UTF-8"
          class="prd-AddToCart_Form gtm-Atc_ProductPage"
          data-push-cart-form
          data-product-form
          data-product-handle="${product.handle}"
          data-gtm-target-context="product-card-form"
          data-product-drawer-external-el="addtocart-product-form"
        >
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">

          <div class="prd-AddToCart_Buttons">
            <input type="hidden" name="id" value="${variant.id}">
            <input type="hidden" name="quantity" value="1">

            <button
              class="prd-AddToCart_Button prd-AddToCart_Button-addtocart btn-Button btn-Button-primary btn-Button-fullWidth btn-Button-square"
              type="submit"
              name="add"
              data-product-quickbuy-el="add"
            >
              <span class="prd-AddToCart_ButtonText">
                ${window.theme.strings.products.product.add_to_cart}
              </span>
            </button>
          </div>
        </form>
      </product-form>
    </div>
  `
}

/**
 * ProductCard template
 * ------------------------------------------------------------------------------
 * Returns an HTML string for a product card using the given params.product.
 *
 * @param {Object} params.product - The parameters for rendering the product card.
 */

function ProductCard (params) {
  if (!params.product) {
    return ''
  }

  const product = params.product
  const type = params.type || 'results'

  const imageSizes =
    type === 'results'
      ? '(max-width: 899px) 50vw, (min-width: 900px) 25vw'
      : '(max-width: 767px) 50vw, (min-width: 900px) 16vw'

  const imageWidths = [160, 320, 540, 720, 900]
  const buildShopifySrcset = imageUrl => {
    if (!imageUrl) return ''

    try {
      const baseUrl = new URL(imageUrl, window.location.origin)
      if (!baseUrl.hostname.includes('cdn.shopify.com')) return ''

      return imageWidths
        .map(width => {
          const sizedUrl = new URL(baseUrl.toString())
          sizedUrl.searchParams.set('width', width)
          return `${sizedUrl.toString()} ${width}w`
        })
        .join(', ')
    } catch {
      return ''
    }
  }

  const mainShopifySrcset = buildShopifySrcset(product.imageUrl)
  const hoverImageUrl =
    (product.alternateImageUrls && product.alternateImageUrls[0]) || ''
  const hoverShopifySrcset = buildShopifySrcset(hoverImageUrl)

  const colorsAvailableField =
    product.customFields
      ?.filter(field => field.key.startsWith('colors-available'))[0]
      ?.value.split(',') || []

  const props = {
    available: true,
    handle: product.url.split('/').pop() || '',
    id: product.productId || '',
    defaultVariantId: product.skus?.[0].id || '',
    url: product.url || '',
    compareAtPrice: product.listPrice || false,
    price: product.price || '',
    title: product.name || '',
    variants: product.skus || [],
    mainImage: mainShopifySrcset
      ? { srcset: mainShopifySrcset, alt: product.name || '' }
      : { src: product.imageUrl || '', alt: product.name || '' },
    hoverImage: hoverShopifySrcset
      ? { srcset: hoverShopifySrcset, alt: product.name || '' }
      : { src: hoverImageUrl, alt: product.name || '' },
    strapline:
      product.customFields?.find(
        field => field.key === 'product_details-strapline',
      )?.value || '',
    colors: colorsAvailableField,
    tags: product.tags1 || [],
    hasCupSize: hasCupSizeOption(product.customFields),
  }

  return `
    <product-card class="prd-Card ${
      props.available ? '' : 'prd-Card-unavailable'
    }" data-product-handle="${props.handle}" data-product-url="${
    props.url
  }" data-product-id="${props.id}">
      <div class="prd-Card_Actions">
        <button
           class="prd-Card_Action prd-Card_Action-wishlist"
            data-product-card-el="wishlistButton"
            data-wishlist-button
            data-product-id="${props.id}"
            data-variant-id="${props.defaultVariantId}"
            data-product-url="${props.url}"
            data-product-price="${props.price}"
            data-product-title="${props.title}"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linejoin="round" d="M16.255 4.7a4.61 4.61 0 0 1 4.6 4.377l.006.229c0 2.268-1.417 4.727-4.427 7.303a28 28 0 0 1-4.43 3.09h-.005a28 28 0 0 1-3.91-2.657l-.52-.433c-3.01-2.576-4.428-5.035-4.428-7.303a4.61 4.61 0 0 1 4.605-4.607c1.634 0 3.027.734 3.84 1.937a.5.5 0 0 0 .829 0c.814-1.203 2.207-1.936 3.84-1.937Z"/>
          </svg>
        </button>
      </div>

      <div class="prd-Card_OverlayContainer">
        <div class="prd-Card_Overlay ${
          props.available ? '' : 'prd-Card_Overlay-unavailable'
        }">
          <product-card-carousel>
            <ul class="prd-Card_Images prd-Card_Carousel" data-product-card-carousel-el="carousel">
              <li class="prd-Card_Image prd-Card_CarouselImage util-FauxLink">
                <a class="util-FauxLink_Link" href="${
                  props.url
                }" tabindex="-1"></a>
                <div class="prd-Card_Image">
                  ${
                    props.mainImage.srcset
                      ? `<img class="rsp-Image_Image" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" srcset="${
                          props.mainImage.srcset
                        }" sizes="${imageSizes}" alt="${
                          props.mainImage.alt
                        }" loading="${
                          params.index < 8 ? 'eager' : 'lazy'
                        }" width="900" height="1350" />`
                      : `<img class="rsp-Image_Image" src="${
                          props.mainImage.src
                        }" alt="${props.mainImage.alt}" loading="${
                          params.index < 8 ? 'eager' : 'lazy'
                        }" width="900" height="1350" />`
                  }
                </div>
              </li>
              <li class="prd-Card_Image prd-Card_HoverImage prd-Card_CarouselImage util-FauxLink">
                <div class="prd-Card_Image">
                  ${
                    props.hoverImage.srcset
                      ? `<img class="rsp-Image_Image" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" srcset="${
                          props.hoverImage.srcset
                        }" sizes="${imageSizes}" alt="${
                          props.hoverImage.alt
                        }" loading="${
                          params.index < 8 ? 'eager' : 'lazy'
                        }" width="900" height="1350" />`
                      : `<img class="rsp-Image_Image" src="${
                          props.hoverImage.src
                        }" alt="${props.hoverImage.alt}" loading="${
                          params.index < 8 ? 'eager' : 'lazy'
                        }" width="900" height="1350" />`
                  }
                </div>
              </li>
            </ul>
          </product-card-carousel>

          <div class="prd-Card_QuickBuyOverlay prd-Card_QuickBuyOverlay-desktop" data-product-card-el="quickBuyOverlay"></div>
          <div class="prd-Card_QuickBuyContainer">
            ${quickBuyTemplate(props)}
          </div>
        </div>
      </div>

      <div class="prd-Card_ContentWrapper util-FauxLink">
        <a class="prd-Card_FauxLink util-FauxLink_Link" href="${
          props.url
        }" data-card-carousel-external-el="hover">
          <span class="util-ScreenReaderOnly">
            ${props.title} for ${props.price}
          </span>
        </a>

        <div class="prd-Card_Content">
          <button type="button" class="prd-Card_QuickBuyTrigger" data-product-card-el="mobileTrigger" data-product-handle="annelise-premium-jersey-one-shoulder-gown-in-blush-pink"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M21.981 6.63a1.32 1.32 0 0 0-.989-.442h-4.68V6a4.313 4.313 0 0 0-8.625 0v.188h-4.68a1.313 1.313 0 0 0-1.312 1.466l1.336 11.25a1.32 1.32 0 0 0 1.312 1.159h15.313a1.32 1.32 0 0 0 1.313-1.16l1.336-11.25a1.31 1.31 0 0 0-.324-1.022M8.812 6a3.187 3.187 0 1 1 6.375 0v.188H8.812zM19.85 18.772a.187.187 0 0 1-.193.166H4.343a.187.187 0 0 1-.193-.166L2.812 7.522a.18.18 0 0 1 .046-.144.2.2 0 0 1 .148-.066h4.681V9.75a.562.562 0 1 0 1.125 0V7.313h6.375V9.75a.563.563 0 0 0 1.125 0V7.313h4.68a.19.19 0 0 1 .187.132.2.2 0 0 1 .007.077z"></path></svg>
            <span class="util-ScreenReaderOnly">
              Quick Buy
            </span>
            </button>
          <div class="prd-Card_MetaWrapper">
            <p class="prd-Card_Strapline">
              ${props.strapline}
            </p>
          </div>
          <div class="prd-Card_Title fz-14_20">
            ${props.title}
          </div>
        </div>

        <div class="prd-Card_Footer">
          <div class="prd-Card_Container fz-14_20">
            <div class="prd-Card_Price ${
              props.compareAtPrice > props.price ? 'prd-Price_Price-sale' : ''
            }">
              ${window.BAO.utils.formatMoney(
                props.price * 100,
                window.theme.moneyFormat,
              )}
            </div>
            ${
              props.compareAtPrice > props.price
                ? `<div class="prd-Price_Previous fz-13_19">
                  ${window.BAO.utils.formatMoney(
                    props.compareAtPrice * 100,
                    window.theme.moneyFormat,
                  )}
                </div>`
                : ''
            }
          </div>

           <product-colors data-section-id="product-card-colors" data-product-handle="${
             props.handle
           }">
            <div class="prd-Card_Colors">
                <div class="prd-Card_ColorContainer">
                  ${props.colors
                    .slice(0, 3)
                    .map(color => {
                      const colorVariant = color
                        .split(':')
                        .pop()
                        .trim()
                      return `
                        <span class="prd-Card_Color prd-Card_Color-${colorVariant.toLowerCase()} col-Color-${colorVariant.toLowerCase()}"></span>
                      `
                    })
                    .join('')}

                </div>

                ${
                  props.colors.length > 3
                    ? `<span class="prd-Card_ColorCount">+${props.colors
                        .length - 3}</span>`
                    : ''
                }
              </div>
            </product-colors>
        </div>
      </div>


    </product-card>
  `
}

function quickBuyTemplate (product) {
  const closeButton = `
    <button class="prd-QuickBuy_Close" type="button" onClick="window.quickBuy.handleClose(event)">
      <span class="prd-QuickBuy_Icon prd-QuickBuy_Icon-close">
        ${ICON_CLOSE}
      </span>
      <span class="util-ScreenReaderOnly">
        ${window.theme.strings.accessibility.close}
      </span>
    </button>
  `

  if (product.available && product.variants.length > 1) {
    return `
      <button
        type="button"
        class="btn-Button btn-Button-tertiary prd-QuickBuy_Trigger"
        data-product-card-el="desktopTrigger"
        data-buy-trigger
      >
        ${window.theme.strings.products.product.quick_buy}
      </button>

      <div
        class="prd-Card_QuickBuy prd-Card_QuickBuy-desktop"
        data-product-card-el="quickBuyContainer"
        aria-hidden="true"
      >
        <section class="prd-QuickBuy">
          ${closeButton}
          ${quickBuyProductFormTemplate(product)}
        </section>
      </div>
    `
  }

  if (product.available && product.variants.length === 1) {
    return `
      <div class="prd-Card_AddToCart">
        ${singleVariantAddToCartTemplate(product)}
      </div>

      <div
        class="prd-Card_QuickBuy prd-Card_QuickBuy-desktop"
        data-product-card-el="quickBuyContainer"
        aria-hidden="true"
      >
        <section class="prd-QuickBuy">
          ${closeButton}
          ${quickBuyProductFormTemplate(product)}
        </section>
      </div>
    `
  }
}

if (window.theme.results) {
  window.theme.results.templates.ProductCard = ProductCard
}

if (window.theme.autocomplete) {
  window.theme.autocomplete.templates.ProductCard = ProductCard
}
